<template>
  <div
    v-if="whatsappStyle"
    id="preguntas"
    class="wa-chat-list"
  >
    <div
      v-for="(chatW, i) in filterChats"
      v-if="i <= limiteVisible"
      :key="chatW.usuario"
      :class="[
        'wa-contact',
        {
          'wa-contact-active': chatEstaActivo(chatW),
          'wa-contact-checked': permitirSeleccion && chatEstaSeleccionado(chatW),
        },
      ]"
      @click="seleccionarChat(chatW)"
    >
      <div
        v-if="permitirSeleccion"
        class="wa-contact-check"
        @click.stop="toggleSeleccion(chatW)"
      >
        <v-icon
          :color="chatEstaSeleccionado(chatW) ? '#00a884' : '#8696a0'"
          size="22"
        >
          {{ chatEstaSeleccionado(chatW) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
        </v-icon>
      </div>

      <div class="wa-contact-avatar-wrap">
        <v-badge
          :value="chatW.totalMensajes >= 4"
          color="#f15c6d"
          dot
          offset-x="8"
          offset-y="8"
        >
          <v-avatar :color="!chatW.nombre ? '#00a884' : '#dfe5e7'" size="48">
            <v-icon color="white" v-if="!chatW.nombre">mdi-account</v-icon>
            <span v-else class="wa-avatar-text">{{ chatW.nombre }}</span>
          </v-avatar>
        </v-badge>
      </div>

      <div class="wa-contact-body">
        <div class="wa-contact-top">
          <div class="wa-contact-name">
            <v-icon small v-if="chatW.idetiquetas" :color="chatW.color">mdi-label</v-icon>
            <v-icon x-small color="orange" v-if="chatW.reasignado">mdi-circle</v-icon>
            {{ tituloListaChat(chatW) }}
          </div>
          <div class="wa-contact-time">{{ horaChat(chatW) }}</div>
        </div>

        <div class="wa-contact-middle" v-if="subtituloListaChat(chatW)">
          {{ subtituloListaChat(chatW) }}
        </div>

        <div class="wa-contact-bottom">
          <div class="wa-last-message">
            <v-icon small class="mr-1" v-if="chatW.mio" color="#8696a0">mdi-check-all</v-icon>
            {{ resumenMensaje(chatW) }}
          </div>
          <div class="wa-contact-badges">
            <!-- Admin: contacto ya inscrito (sigue visible en lista mezclada) -->
            <v-chip
              v-if="Number(chatW.inscrito) === 1"
              x-small
              label
              dark
              color="green darken-2"
              class="wa-chip-prio"
              title="Alumno inscrito (también en Recepción)"
            >
              <v-icon x-small left>mdi-school</v-icon>
              Inscrito
            </v-chip>
            <!-- Marca permanente: entró por Susana (solo usuarios autorizados) -->
            <v-chip
              v-if="mostrarMarcaViaSusana(chatW)"
              x-small
              label
              dark
              color="purple darken-2"
              class="wa-chip-prio"
              title="Entró por Susana (IA)"
            >
              <v-icon x-small left>mdi-robot</v-icon>
              IA
            </v-chip>
            <!-- Control: Atención OR Manual OR IA (uno solo) -->
            <v-chip
              v-if="chatRequiereAtencion(chatW)"
              x-small
              label
              dark
              color="red darken-2"
              class="wa-chip-prio"
              :title="tituloAtencion(chatW)"
            >
              <v-icon x-small left>mdi-alert-circle</v-icon>
              Atención
            </v-chip>
            <v-chip
              v-else-if="chatW.control_conversacion || chatW.humano_tomo_control != null"
              x-small
              label
              dark
              :color="chatEnControlManual(chatW) ? 'deep-orange darken-1' : 'teal darken-1'"
              :title="chatEnControlManual(chatW) ? 'Control manual' : 'Control IA'"
            >
              <v-icon x-small left>
                {{ chatEnControlManual(chatW) ? 'mdi-account-tie' : 'mdi-robot' }}
              </v-icon>
              {{ chatEnControlManual(chatW) ? 'Manual' : 'IA' }}
            </v-chip>
            <!-- Embudo: solo etapa más avanzada (no Examen+Beca+Pago a la vez) -->
            <v-chip
              v-if="chatW.metodos_pago_enviados"
              x-small
              label
              dark
              color="green darken-1"
              title="Métodos de pago enviados"
            >
              <v-icon x-small left>mdi-cash</v-icon>
              Pago
            </v-chip>
            <v-chip
              v-else-if="chatW.llego_beca"
              x-small
              label
              dark
              color="indigo darken-1"
              title="Llegó a beca"
            >
              <v-icon x-small left>mdi-school</v-icon>
              Beca
            </v-chip>
            <v-chip
              v-else-if="chatW.llego_examen"
              x-small
              label
              dark
              color="red darken-1"
              title="Llegó a examen"
            >
              <v-icon x-small left>mdi-clipboard-text</v-icon>
              Examen
            </v-chip>
            <v-chip
              v-if="Number(chatW.es_recomendado) === 1"
              x-small
              label
              dark
              color="deep-purple"
              class="wa-rec-chip"
              title="Recomendado"
            >
              rec
            </v-chip>
            <v-chip
              v-if="chatW.tiemporestante !== undefined && chatW.tiemporestante !== null"
              x-small
              label
              dark
              class="wa-time-chip"
              :color="chatW.tiemporestante > 2 ? 'green' : (chatW.tiemporestante > 0 ? 'yellow' : 'red')"
            >
              {{ chatW.tiemporestante }}
              <v-icon x-small right>mdi-clock</v-icon>
            </v-chip>
            <span
              v-if="mostrarChipSinLeer(chatW)"
              :class="['wa-unread', { 'wa-unread-reasignado': esReasignado(chatW) }]"
            >
              {{ contadorSinLeer(chatW) }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="limiteVisible < (filterChats || []).length - 1" class="pa-3">
      <v-btn color="#00a884" dark block rounded depressed @click="onCargarMas">
        Mostrar más conversaciones
      </v-btn>
    </div>
  </div>

  <div
    v-else
    :style="`height: ${tamanioPantalla}px; overflow: auto;`"
    id="preguntas"
  >
    <v-list dense class="elevation-0">
      <template v-for="(chatW, i) in filterChats" :kei="i" v-if="i <= limiteVisible">
        <v-divider inset v-if="i > 0"></v-divider>


        <v-list-item
          @click="seleccionarChat(chatW)"
          :class="[
            chatEstaActivo(chatW) ? 'wa-list-item-active' : '',
            permitirSeleccion && chatEstaSeleccionado(chatW) ? 'wa-list-item-checked' : '',
          ]"
        >
        <v-list-item-action
          v-if="permitirSeleccion"
          class="mr-1"
          @click.stop="toggleSeleccion(chatW)"
        >
          <v-icon :color="chatEstaSeleccionado(chatW) ? 'success' : 'grey'">
            {{ chatEstaSeleccionado(chatW) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
          </v-icon>
        </v-list-item-action>
        <!-- AVATAR -->
        <!-- ICONO FLOTANTE -->
        <v-icon
        class="avatar-badge"
        color="red"
        small
        v-if="chatW.totalMensajes >= 4"
        >
        mdi-message-badge
      </v-icon>
      <v-list-item-avatar
      :color="!chatW.nombre ? '#00A548' : 'grey lighten-3'"
      >
      
      <!-- CONTENIDO DEL AVATAR -->
      <v-icon color="white" v-if="!chatW.nombre">mdi-account</v-icon>
      <span v-if="chatW.nombre">{{ chatW.nombre }}</span>
    </v-list-item-avatar>
    
    <!-- contenido del contacto -->
    <v-list-item-content>
      
            <!-- Nombre del contacto: solo vendedora asignada -->
              <v-list-item-title v-if="chatW.vendedor">{{ chatW.vendedor.nombre }}</v-list-item-title>
              <v-list-item-title>
        <v-icon v-if="chatW.idetiquetas" :color="chatW.color">mdi-label</v-icon>
        <v-icon small color="orange" v-if="chatW.reasignado">mdi-circle</v-icon>{{ getNombre(chatW) }}
              <v-chip x-small color="green darken-2" dark v-if="Number(chatW.inscrito) === 1" class="ml-2">
                <v-icon x-small left>mdi-school</v-icon>Inscrito
              </v-chip>
              <v-chip
                x-small
                label
                dark
                color="deep-purple"
                class="ml-2"
                title="Recomendado"
                v-if="Number(chatW.es_recomendado) === 1"
              >rec</v-chip>
              <v-chip x-small color="green" dark v-if="chatW.tiemporestante > 2"       class="ml-2">{{ chatW.tiemporestante }}<v-icon x-small right>mdi-clock</v-icon></v-chip>
              <v-chip x-small color="yellow"     v-else-if="chatW.tiemporestante > 0"  class="ml-2">{{ chatW.tiemporestante }}<v-icon x-small right>mdi-clock</v-icon></v-chip>
              <v-chip x-small color="red"   dark v-else                                class="ml-2">{{ chatW.tiemporestante }}<v-icon x-small right>mdi-clock</v-icon></v-chip>
              <v-chip x-small :color="chipCityColor(chatW)" v-if="chatW && chatW.city" :class="'ml-2 white--text'">{{ chatW.city.toUpperCase() }}</v-chip>
            </v-list-item-title> 

            <!-- Cuerpo del contacto -->
            <v-list-item-subtitle >
              <!-- VISTO -->
              <v-icon 
                small 
                class="mr-1" 
                v-if="chatW.mio" 
                color="grey"
              >
                mdi-check-all
              </v-icon>


              <!-- MOSTRAR ULTIMO MENSAJE -->
              <span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                    > 
                      <span v-if="chatW.type == 1">{{ chatW.mensaje }}</span>
                      <span v-if="chatW.type == 2">Imagen</span>
                      <span v-if="chatW.type == 3">Audio</span>
                      <span v-if="chatW.type == 4">PDF</span>
                    </span>
                  </template>
                  <!-- mostrar texto -->
                  <span v-if="chatW.type == 1">{{ chatW.mensaje }}</span>

                  <!-- Mostrar miniatura de la imagen -->
                  <span v-if="chatW.type == 2">
                    <img v-if="chatW.mio == 0" :src="url2 + chatW.MediaUrl0" alt="Red dot" width="100"/>
                    <img v-if="chatW.mio == 1" :src="url2 + chatW.MediaUrl0" alt="Red dot" width="100"/>
                  </span>

                  <!-- Tipo de mensaje es un audio -->
                  <span v-if="chatW.type == 3">Audio, abrir para escuchar</span>

                  <!-- Tipo PDF -->
                  <span v-if="chatW.type == 4">PDF, abrir para verlo</span>
                </v-tooltip>
              </span>   

            </v-list-item-subtitle>

          </v-list-item-content>


          <v-list-item-icon>
            <!-- HORA DEL CHAT -->
            <v-list-item-action-text >
              {{ chatW.ultimmensaje }}
            </v-list-item-action-text>
            <v-list-item-action-text >
              {{ chatW.fecha_ultimo_mensaje }}
            </v-list-item-action-text>

            <!-- Marcador para saber cuando mensaje no leídos son -->
            <v-chip
              v-if="mostrarChipSinLeer(chatW)"
              :color="esReasignado(chatW) ? 'blue' : (chatW.mio == 0 ? 'green' : '')"
              small
              dark
              class="pa-2"
            >
              {{ contadorSinLeer(chatW) }}
            </v-chip>
          </v-list-item-icon>

        </v-list-item>

        <div v-if="limiteVisible == i" >
          <v-btn color="success" @click="onCargarMas" block tile>Mostrar más mensajes +50</v-btn>
        </div>
      </template>
    </v-list>
  </div>
</template>
<script>
  import axios          from 'axios';
  import { mapGetters, mapActions } from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import MensajesWppTwilio     from '@/components/whatsapp/MensajesTwilioWpp.vue';
  import validarErrores        from '@/mixins/validarErrores'
  import { chatViaAgenteIA } from '@/utils/twilioVendedoraProspecto'

  export default {

  	props:{
      filterChats: Array,
      limite: { type: Number, default: 100 },
      whatsappStyle: { type: Boolean, default: false },
      /** Chat abierto en el padre; mantiene la selección aunque la lista se refresque */
      chatActivo: { type: Object, default: null },
      /** Chip permanente "IA" (Susana); solo visible para usuarios autorizados de la vista padre */
      mostrarMarcaIaSusana: { type: Boolean, default: false },
      /** Muestra checkboxes para reasignación / acciones masivas */
      permitirSeleccion: { type: Boolean, default: false },
      /** Chats marcados desde el padre (objetos con usuario) */
      seleccionados: { type: Array, default: () => [] },
    },

    components:{
      Alerta,
      carga,
      MensajesWppTwilio,
    },

    mixins: [ validarErrores ],


    data: () => ({
      chat:null,
      limiteBoost: 0,
      url :'https://academicokpi.club/imagenes-whatsapp/',
      url2: 'https://escuelakpi.club/imagenes-whatsapp/',
    }),

    computed: {
      tamanioPantalla () {
        return this.$vuetify.breakpoint.height - 330
      },
      limiteVisible () {
        return (Number(this.limite) || 0) + this.limiteBoost
      },
    },

    watch:{
      filterChats (newVal, oldVal) {
        if (!oldVal || !Array.isArray(newVal) || !Array.isArray(oldVal)) {
          this.limiteBoost = 0
          return
        }
        if (newVal.length !== oldVal.length) {
          this.limiteBoost = 0
        }
      },

      limite () {
        this.limiteBoost = 0
      },
    },

    async created (){

    },

    methods: {
      onCargarMas () {
        const nextVisible = this.limiteVisible + 50
        this.limiteBoost = 0
        this.$emit('cargar-mas', {
          limiteVisible: nextVisible,
          total: Array.isArray(this.filterChats) ? this.filterChats.length : 0,
        })
      },

      seleccionarChat (chatW) {
        this.chat = chatW
        this.$emit('verChat', chatW)
      },

      claveChat (chatW) {
        if (!chatW) return ''
        return String(chatW.usuario != null ? chatW.usuario : (chatW.idprospectos || ''))
      },

      chatEstaSeleccionado (chatW) {
        const clave = this.claveChat(chatW)
        if (!clave) return false
        return (this.seleccionados || []).some((c) => this.claveChat(c) === clave)
      },

      toggleSeleccion (chatW) {
        if (!this.permitirSeleccion || !chatW) return
        const clave = this.claveChat(chatW)
        const actual = Array.isArray(this.seleccionados) ? [...this.seleccionados] : []
        const idx = actual.findIndex((c) => this.claveChat(c) === clave)
        if (idx >= 0) {
          actual.splice(idx, 1)
        } else {
          actual.push(chatW)
        }
        this.$emit('update:seleccionados', actual)
        this.$emit('seleccion-change', actual)
      },

      chatEstaActivo (chatW) {
        const activo = this.chatActivo || this.chat
        if (!activo || !chatW) return false
        if (activo.usuario != null && chatW.usuario != null) {
          return String(activo.usuario) === String(chatW.usuario)
        }
        return activo === chatW
      },

      esReasignado (chatW) {
        return !!(chatW && (Number(chatW.reasignado) === 1 || chatW.reasignado === true))
      },

      esViaSusana (chatW) {
        return chatViaAgenteIA(chatW)
      },

      mostrarMarcaViaSusana (chatW) {
        return this.mostrarMarcaIaSusana && this.esViaSusana(chatW)
      },

      mostrarChipSinLeer (chatW) {
        if (!chatW) return false
        if (this.esReasignado(chatW)) return true
        return chatW.sinleer > 0 || chatW.mio == 0
      },

      contadorSinLeer (chatW) {
        if (this.esReasignado(chatW)) {
          return Math.max(Number(chatW.sinleer) || 0, 1)
        }
        return chatW.sinleer > 0 ? chatW.sinleer : 1
      },

      chipCityColor(chat){
        if (chat && chat.city) {
          if (chat.city == "cdmx") {
            return "pink accent-4"
          }
          if (chat.city == "mty") {
            return "deep-orange accent-3"
          }
          if (chat.city == "gdl") {
            return "teal accent-4"
          }
        }

        return "teal darken-1"
      },
    	getNombre( texto ){
        let nombre = texto.usuario.replace('whatsapp:+52','')
        return nombre
      },

      chatEnControlManual (chat = {}) {
        if (!chat || typeof chat !== 'object') return false
        if (chat.humano_tomo_control === true || chat.humano_tomo_control === 1) return true
        if (String(chat.control_conversacion || '').toLowerCase() === 'humano') return true
        if (chat.ia_puede_responder === false || chat.ia_puede_responder === 0) return true
        return false
      },

      chatRequiereAtencion (chat = {}) {
        if (!chat || typeof chat !== 'object') return false
        if (chat.requiere_atencion === true || chat.requiere_atencion === 1) return true
        if (String(chat.etiqueta_atencion || '').toUpperCase() === 'ATENCION') return true
        if (/^atencion:/i.test(String(chat.motivo_pausa_ia || ''))) return true
        return false
      },

      tituloAtencion (chat = {}) {
        const motivo = String(chat.motivo_pausa_ia || '').replace(/^atencion:/i, '').trim()
        return motivo
          ? `ATENCIÓN — ${motivo}. La IA está pausada; toma el chat.`
          : 'ATENCIÓN — La IA no resolvió bien; está pausada. Toma el chat.'
      },

      tituloListaChat (chatW) {
        if (chatW && chatW.vendedor && chatW.vendedor.nombre) {
          return chatW.vendedor.nombre
        }
        return this.telefonoContacto(chatW)
      },

      subtituloListaChat (chatW) {
        if (!chatW) return ''
        if (chatW.vendedor && chatW.vendedor.nombre) {
          return this.telefonoContacto(chatW)
        }
        return ''
      },

      telefonoContacto (chatW) {
        return String((chatW && chatW.usuario) || '').replace('whatsapp:+52', '')
      },

      horaChat (chatW) {
        return chatW.fecha_ultimo_mensaje || chatW.ultimmensaje || chatW.ultimomensaje || ''
      },

      resumenMensaje (chatW) {
        if (!chatW) return ''

        if (chatW.type == 2) return 'Imagen'
        if (chatW.type == 3) return 'Audio'
        if (chatW.type == 4) return 'PDF'
        if (chatW.type == 5) return 'Video'

        return chatW.mensaje || 'Sin mensajes'
      },
    },
  }
</script>

<style scoped lang="scss">
@import '@/assets/styles/twilio-whatsapp-layout.scss';

  .wa-contact-check {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 28px;
    margin-right: 2px;
    cursor: pointer;
  }

  .wa-contact-checked {
    background: #e7f8f2 !important;
  }

  .wa-list-item-active {
    background: #c8efe4 !important;
    box-shadow: inset 5px 0 0 #008f6f;
  }

  .wa-list-item-active:hover {
    background: #c8efe4 !important;
  }

  .wa-list-item-checked {
    background: #e7f8f2 !important;
  }

  #mensajesChat{
    background-image: url("/fondo_whatsapp.jpg");
    background-repeat: repeat-y;
    background-repeat: repeat-x;
    background-size:contain;
  }

  #preguntas::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > #preguntas::-webkit-scrollbar:vertical {
    width: 4px !important;
  }

  #preguntas::-webkit-scrollbar:vertical{
    width: 4px !important;
  }

  #preguntas::-webkit-scrollbar-button:increment,#preguntas::-webkit-scrollbar-button{
    display: none;
  }

  #preguntas::-webkit-scrollbar:horizontal{
    display: none;
  }

  #preguntas::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  /**********************************/

  #mensajesChat::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > #mensajesChat::-webkit-scrollbar:vertical {
    width: 4px !important;
  }

  #mensajesChat::-webkit-scrollbar:vertical{
    width: 4px !important;
  }

  #mensajesChat::-webkit-scrollbar-button:increment,#mensajesChat::-webkit-scrollbar-button{
    display: none;
  }

  #mensajesChat::-webkit-scrollbar:horizontal{
    display: none;
  }

  #mensajesChat::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  .container {
    padding:0;
    background-color: #FFF; 
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    height: 750px;
    margin-top: 25px;
  }

  /* ===== MENU ===== */
  .menu {
    float: left;
    height: 700px;;
    width: 70px;
    background: #4768b5;
    background: -webkit-linear-gradient(#4768b5, #35488e);
    background: -o-linear-gradient(#4768b5, #35488e);
    background: -moz-linear-gradient(#4768b5, #35488e);
    background: linear-gradient(#4768b5, #35488e);
    box-shadow: 0 10px 20px rgba(0,0,0,0.19);
  }

  .menu .items {
    list-style:none;
    margin: auto;
    padding: 0;
  }

  .menu .items .item {
    height: 70px;
    border-bottom: 1px solid #6780cc;
    display:flex;
    justify-content: center;
    align-items: center;
    color: #9fb5ef;
    font-size: 17pt;
  }

  .menu .items .item-active {
    background-color:#5172c3;
    color: #FFF;
  }

  .menu .items .item:hover {
    cursor: pointer;
    background-color: #4f6ebd;
    color: #cfe5ff;
  }

  /* === CONVERSATIONS === */

  .discussions {
    width: 100%;
    height: 702px;
    box-shadow: 0px 8px 10px rgba(0,0,0,0.20);
    overflow: hidden;
    display: inline-block;
  }

  .discussions .discussion {
    width: 100%;
    height: 90px;
    background-color: #FAFAFA;
    display:flex;
    align-items: center;
    cursor: pointer;
  }

  .discussions .search {
    display:flex;
    align-items: center;
    justify-content: center;
    color: #E0E0E0;
  }

  .discussions .search .searchbar {
    height: 40px;
    background-color: #FFF;
    width: 70%;
    padding: 0 20px;
    border-radius: 50px;
    border: 1px solid #EEEEEE;
    display:flex;
    align-items: center;
    cursor: pointer;
  }

  .discussions .search .searchbar input {
    margin-left: 15px;
    height:38px;
    width:100%;
    border:none;
    font-family: 'Montserrat', sans-serif;;
  }

  .discussions .search .searchbar *::-webkit-input-placeholder {
      color: #E0E0E0;
  }
  .discussions .search .searchbar input *:-moz-placeholder {
      color: #E0E0E0;
  }
  .discussions .search .searchbar input *::-moz-placeholder {
      color: #E0E0E0;
  }
  .discussions .search .searchbar input *:-ms-input-placeholder {
      color: #E0E0E0;
  }

  .discussions .message-active {
    height: 90px;
    background-color: #FFF;
    border-right: solid 5px #E91E63;
  }

  .discussions .discussion .photo {
    margin-left:20px;
    display: block;
    width: 45px;
    height: 45px;
    background: #E6E7ED;
    -moz-border-radius: 50px;
    -webkit-border-radius: 50px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .online {
    position: relative;
    top: 30px;
    left: 35px;
    width: 13px;
    height: 13px;
    background-color: #8BC34A;
    border-radius: 13px;
    border: 3px solid #FAFAFA;
  }

  .desc-contact {
    height: 43px;
    width:50%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .discussions .discussion .name {
    margin: 0 0 0 20px;
    font-family:'Montserrat', sans-serif;
    font-size: 11pt;
    color:#515151;
  }

  .discussions .discussion .message {
    margin: 6px 0 0 20px;
    font-family:'Montserrat', sans-serif;
    font-size: 9pt;
    color:#515151;
  }

  .timer {
    margin-left: 15%;
    font-family:'Open Sans', sans-serif;
    font-size: 11px;
    padding: 3px 8px;
    color: #BBB;
    background-color: #FFF;
    border: 1px solid #E5E5E5;
    border-radius: 15px;
  }

  .chat {
    width: calc(100%);
  }

  .chat .messages-chat {
    padding: 25px 10px;
  }

  .chat .messages-chat .message {
    display:flex;
    align-items: center;
    margin-bottom: 2px;
  }

  .chat .messages-chat .message .photo {
    display: block;
    width: 45px;
    height: 45px;
    background: #E6E7ED;
    -moz-border-radius: 50px;
    -webkit-border-radius: 50px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .chat .messages-chat .text {
    margin: 0 35px;
    background-color: #f6f6f6;
    padding: 15px;
    border-radius: 12px;
  }

  .text-only {
    white-space: pre-line;
  }

  .time {
    font-size: 12px;
    color:lightgrey;
    margin-bottom:10px;
    margin-left: 38px;
  }

  .response-time {
    float: right;
    margin-right: 40px !important;
  }

  .response {
    float: right;
    margin-right: 0px !important;
    margin-left: auto; /* flexbox alignment rule */
    max-width: 90%;
  }

  .noresponse {
    max-width: 90%;
  }

  .response .text {
    background-color: #E91E63 !important;
    color: white;
  }

  .footer-chat {
    width: calc(65% - 66px);
    height: 80px;
    display:flex;
    align-items: center;
    position:absolute;
    bottom: 0;
    background-color: transparent;
    border-top: 2px solid #EEE;
    
  }

  .chat .footer-chat .icon {
    margin-left: 30px;
    color:#C0C0C0;
    font-size: 14pt;
  }

  .chat .footer-chat .send {
    color:#fff;
    background-color: #4f6ebd;
    position: absolute;
    right: 50px;
    padding: 12px 12px 12px 12px;
    border-radius: 50px;
    font-size: 14pt;
  }

  .chat .footer-chat .name {
    margin: 0 0 0 20px;
    text-transform: uppercase;
    font-family:'Montserrat', sans-serif;
    font-size: 13pt;
    color:#515151;
  }

  .chat .footer-chat .right {
    position: absolute;
    right: 40px;
  }

  .avatar-wrapper {
    position: relative;
  }

  .avatar-badge {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 10;
    background: transparent;      /* opcional para que se vea bien */
    border-radius: 50%;
    padding: 2px;
  }

</style>
